<!-- /* <style>
/* Custom CSS for the blur effect */
.backdrop-blur {
filter: blur(5px);
transition: filter 0.3s ease-in-out;
}
</style> */ -->
<ul class="nav nav-tabs mb-3" *ngIf="isClinicClient">
  <li class="nav-item">
    <a class="nav-link" [class.active]="activeTab === 'product'" (click)="setActiveTab('product')"
      style="cursor: pointer;">
      Product Billing
    </a>
  </li>
  <li class="nav-item">
    <a class="nav-link" [class.active]="activeTab === 'service'" (click)="setActiveTab('service')"
      style="cursor: pointer;">
      Service Billing
    </a>
  </li>
</ul>
<div class="content-info" [class.backdrop-blur]="showReportModal">
  <div class="content-title d-flex justify-content-between align-items-center">
    <h3 class="title">Bill Summary</h3>
  </div>

  <!-- Product Billing Section -->
  <div *ngIf="activeTab === 'product'">
    <div class="billing-summary mt-4">
      <!-- Existing Product Billing Content -->
      <div class="row">
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Total Bills</h6>
              <p class="card-text h4">{{ totalBills }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Grand Total</h6>
              <p class="card-text h5 text-primary">
                {{ formatCurrency(totalAmount) }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Total GST</h6>
              <p class="card-text h6 text-info">
                {{ formatCurrency(totalGstAmount) }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Total CESS</h6>
              <p class="card-text h6 text-warning">
                {{ formatCurrency(totalCessAmount) }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Total Discount</h6>
              <p class="card-text h6 text-success">
                {{ formatCurrency(totalDiscountAmount) }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Consumable Bills</h6>
              <p class="card-text h6 text-secondary">{{ consumableBills }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Total Returns</h6>
              <p class="card-text h4">{{ returnsCount }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card text-center">
            <div class="card-body">
              <h6 class="card-title">Refunded</h6>
              <p class="card-text h6 text-danger">
                {{ formatCurrency(returnsTotal) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3 mb-4 align-items-center">
        <div class="col-md-3">
          <div class="card text-center shadow-sm">
            <div class="card-body py-2">
              <h6 class="card-title mb-1 small text-muted">Get Sales Report</h6>
              <button class="btn btn-outline-success btn-sm" (click)="openReportModal()">
                <i class="bi bi-file-earmark-excel"></i> Export CSV
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card text-center shadow-sm">
            <div class="card-body py-2">
              <h6 class="card-title mb-1 small text-muted">Refresh Data</h6>
              <button class="btn btn-outline-secondary btn-sm" [disabled]="isLoading" (click)="refreshData()">
                <i class="bi bi-arrow-clockwise"></i>
                {{ isLoading ? "Loading..." : "Refresh" }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-3 ms-auto">
          <div class="input-group shadow-sm">
            <span class="input-group-text bg-white border-end-0">
              <i class="bi bi-search text-primary"></i>
            </span>
            <input type="text" class="form-control border-start-0 ps-0" [formControl]="search"
              placeholder="Search by customer name or bill #...">
          </div>
        </div>
      </div>

      <div class="common-table">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Billing No.</th>
                <th>Customer</th>
                <th>Billing Date</th>
                <th>Sub Total</th>
                <th>Discount</th>
                <th>GST</th>
                <th>Grand Total</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @if (!filteredBillingList.length) {
              <tr>
                <td colspan="11" class="text-center">
                  @if (isLoading) {
                  <div class="d-flex justify-content-center align-items-center py-3">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <span class="ms-2">Loading billing records...</span>
                  </div>
                  } @else {
                  <span>No billing records found.</span>
                  }
                </td>
              </tr>
              } @for (billing of filteredBillingList; track
              trackByBillingId($index, billing); let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>
                  <a [routerLink]="['/billinglist/', billing.id]" [queryParams]="{ view: true }"
                     [title]="billing.billingNumber ? 'Internal #' + billing.billingNumber : ''">
                    {{ billing.billNo || billing.billingNumber || "N/A" }}
                  </a>
                </td>
                <td>
                  <span class="fw-semibold text-dark">{{ billing.customer?.name || "Cash Customer" }}</span>
                  @if (billing.customer?.phone) {
                    <small class="text-muted d-block">{{ billing.customer.phone }}</small>
                  }
                </td>
                <td>
                  <div>
                    <strong class="text-muted d-block">{{
                      formatDateTime(billing.billingDate)
                      }}</strong>
                  </div>
                </td>
                <td>{{ formatCurrency(billing.subTotal || "0") }}</td>
                <td>
                  {{ formatCurrency(billing.discountAmount || "0") }}
                </td>
                <td>
                  {{ formatCurrency(billing.gstAmount || "0") }}
                </td>
                <td>
                  {{ formatCurrency(billing.grandTotal || "0") }}
                </td>
                <td>
                  <div class="td-actions-btn">
                    <button class="btn btn-success btn-sm" (click)="printBilling(billing.id)" title="Print">
                      <i class="bi bi-printer"></i>
                    </button>
                    <button class="btn btn-warning btn-sm" (click)="downloadPDF(billing.id)" title="Download PDF">
                      <i class="bi bi-download"></i>
                    </button>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      @if (totalCount > pageSize) {
      <div class="d-flex justify-content-center mt-4">
        <nav>
          <ul class="pagination">
            <!-- Previous button -->
            <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
              <a class="page-link">&laquo;</a>
            </li>

            <!-- First Page button -->
            <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
              <a class="page-link">1</a>
            </li>

            <!-- Left Ellipsis -->
            @if (currentPage > 4) {
            <li class="page-item disabled">
              <a class="page-link">...</a>
            </li>
            }

            <!-- Pages Around Current page -->
            @for (page of getVisiblePages(); track page) {
            <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
              <a class="page-link">{{ page }}</a>
            </li>
            }

            <!-- Right Ellipsis -->
            @if (currentPage < totalPages - 3) { <li class="page-item disabled">
              <a class="page-link">...</a>
              </li>
              }

              <!-- Last Page button - only show if more than 1 page -->
              @if (totalPages > 1) {
              <li class="page-item" [class.active]="currentPage === totalPages" (click)="goToPage(totalPages)">
                <a class="page-link">{{ totalPages }}</a>
              </li>
              }

              <!-- Next button -->
              <li class="page-item" [class.disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
                <a class="page-link">&raquo;</a>
              </li>
          </ul>
        </nav>
      </div>
      }

      @if (filteredBillingList.length > 0) {
      <div class="mt-4">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h6 class="mb-0">Recent Billing Details</h6>
              </div>
              <div class="card-body">
                @for (billing of filteredBillingList.slice(0, 2); track
                billing.id) {
                <div class="border-bottom pb-3 mb-3">
                  <div class="row">
                    <div class="col-md-6">
                      <h6>Billing #{{ billing.billingNumber || "N/A" }}</h6>
                      <p class="text-muted mb-1">
                        Date: {{ formatDateTime(billing.billingDate) }}
                      </p>
                      <p class="mb-0">
                        Total:
                        <strong>{{
                          formatCurrency(billing.grandTotal || "0")
                          }}</strong>
                      </p>
                    </div>
                    <div class="col-md-6">
                      @for (product of billing.products?.slice(0, 3); track
                      product.id) {
                      <div class="d-flex justify-content-between small">
                        <span>Item
                          {{ product.id?.substring(0, 8) || "N/A" }}...</span>
                        <span>
                          Qty: {{ product.quantity || 0 }} ×
                          {{ formatCurrency(product.price || "0") }}
                        </span>
                      </div>
                      } @if ((billing.products?.length || 0) > 3) {
                      <small class="text-muted">
                        ... and {{ (billing.products?.length || 0) - 3 }} more
                        items
                      </small>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Service Billing Section -->
  <div *ngIf="activeTab === 'service'">
    <app-service-billing-list></app-service-billing-list>
  </div>

  <!-- Report Modal (Shared) -->
  <div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': showReportModal }"
    [style.display]="showReportModal ? 'block' : 'none'">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="createReportModalLabel">
            Export Data to CSV
          </h5>
          <button type="button" class="btn-close" (click)="closeReportModal()" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="mb-4 p-3 border rounded">
            <div class="mb-3">
              <label class="form-label fw-bold text-dark">Quick Select Presets:</label>
              <div class="d-flex flex-wrap gap-2">
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'today' ? 'btn-success' : 'btn-secondary'
                " (click)="setRelative('today')">
                  Today
                </button>
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'yesterday'
                    ? 'btn-success'
                    : 'btn-secondary'
                " (click)="setRelative('yesterday')">
                  Yesterday
                </button>
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'weekToDate'
                    ? 'btn-success'
                    : 'btn-secondary'
                " (click)="setRelative('weekToDate')">
                  Week to date
                </button>
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'monthToDate'
                    ? 'btn-success'
                    : 'btn-secondary'
                " (click)="setRelative('monthToDate')">
                  Month to date
                </button>
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'yearToDate'
                    ? 'btn-success'
                    : 'btn-secondary'
                " (click)="setRelative('yearToDate')">
                  Year to date
                </button>
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'previousWeek'
                    ? 'btn-success'
                    : 'btn-secondary'
                " (click)="setRelative('previousWeek')">
                  Previous week
                </button>
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'previousMonth'
                    ? 'btn-success'
                    : 'btn-secondary'
                " (click)="setRelative('previousMonth')">
                  Previous month
                </button>
                <button type="button" class="btn" [ngClass]="
                  selectedPreset === 'previousYear'
                    ? 'btn-success'
                    : 'btn-secondary'
                " (click)="setRelative('previousYear')">
                  Previous year
                </button>
              </div>
            </div>

            <div class="mt-3">
              <label class="form-label fw-bold text-dark">Or select a custom range:</label>
              <div class="d-flex align-items-center gap-2">
                <input type="date" class="form-control" [(ngModel)]="fromDate" />
                <span class="text-muted">to</span>
                <input type="date" class="form-control" [(ngModel)]="toDate" />
              </div>
            </div>
            <small class="text-muted mt-2 d-block">Manual date selection overrides any preset choice.</small>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-success" (click)="downloadReport()">
            Download CSV
          </button>
          <button class="btn btn-secondary" (click)="closeReportModal()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>